import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
// import './AdminDashbord/Body.css';
import './Reports.css'
import {Card, Button, 
    Table, OverlayTrigger, Modal} from 'react-bootstrap';
    import Overlay from 'react-bootstrap/Overlay'
import axios from 'axios';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import OverLay from './overlay';
import ReactExport from "react-data-export";
import Edit_delete from './edit_delete_request';
import {useHistory} from 'react-router-dom';
import SelectSchemeReport from './RaiseRequest/SelectSchemeReport.js';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
var scheme_auth=false

let allcorporate=[]

const Requesthistory=(props)=>{

    let history=useHistory()
    let [scheme, setscheme]=useState([])
  let [call_log_user, setget_call_log_user]=useState({})
 let [selected_scheme, setselected_sceme]=useState('')

    //_summery
    const [getcityList, setcityList]=useState([])
    const [serviceName, setserviceName]=useState([])
   
    const [edit_delete_request, setedit_delete_request]=useState(false)
    const [edit_delete_request_input, setedit_delete_request_input]=useState({
        
    })

    const [show_summery, setShow_summery] = useState(false);
    const [target_summery, setTarget_summery] = useState(null);
    const [summery_data, setsummery_data]=useState({})
    const ref_summery = useRef(null);
    const popupmodal=useRef();
    const [checkMisScheme, setceckMisschem]=useState('')

    let [filterdata, setfilterdata]=useState([])
    const [data, setdata]=useState([])
    const[exceldata, setexceldata]=useState([])
    const [indicator, setindecator]=useState(false)
    const [fetchMisforunac, setfetchMisforunacadamy]=useState([])
    const [misforBirhday, setmisforBirhday]=useState([])
    const [misforlogistic, setmisforlogistic]=useState([])
    const [misforeducator, setmisforeducator]=useState([])
    const [misforservicesCopy, setmisforservicescopy]=useState('')
    const [misforservices, setmisforservices]=useState('')
    const [selection_export_excel, setselection_export_excel]=useState([
        {label:'Scheme', isSelected:false, keyname:'scheme'},
        {label:'Request Id', isSelected:false, keyname:'reqId'},
        {label:'Service Name', isSelected:false, keyname:'service'},
        {label:'Date request raised', isSelected:false, keyname:'created_at'},
        {label:'Merchant Name', isSelected:false, keyname:'second_party_name'},
        {label:'City', isSelected:false, keyname:'city'},
        {label:'Description of request (only stamp paper/ stamp paper and docs/ only docs)', isSelected:false, keyname:'description'},
        {label:'Tracking Number', isSelected:false, keyname:'tracking_details'},
        {label:'Courier service name', isSelected:false, keyname:'courier_service'},
        {label:'Date of Docs Delivery (DD-MMM-YY)', isSelected:false, keyname:'date_of_delivery'},
        {label:'Time Taken for delivery', isSelected:false, keyname:'time_taken_for_delivery'},
        {label:'Days Since /n Request Raised for Undelivered cases', isSelected:false, keyname:'date_request_raised'},
    ])
    const [search, setsearch]=useState({
        scheme:'',
        reqId:'',
        sname:'',
        city:'',
        rdate:'',
        ddate:'',
        corporate_id:''
    })
    
    const [buttonselected, setbuttonSelected]=useState([
        {label:'24 hrs', selected:false, val:1},
        {label:'7 days', selected:false, val:7},
        {label:'30 days', selected:false, val:30},
        {label:'90 days', selected:false, val:90},
        {label:'All', selected:false, val:'all'}

    ])
    const [user_list_admin, setget_user_list_admin]=useState([])
    const [selectuser, setsetselectuser]=useState({
        name:props.userData.name,
        id:props.userData.id
    })
    const edit_logistic_educator_delight_gift=()=>{
        // setindecator(true)
        console.log(edit_delete_request_input.service)
        if(edit_delete_request_input.service==="Educator Delight - Admin sheet"){
            setindecator(true)
            axios.post('/edit_logistic_educator_delight_gift', {
                data:edit_delete_request_input,
                user_id:props.userData.id
            }).then((res)=>{
                // console.log('Educator Delight - Admin sheet',res.data)
        setindecator(false)
        setedit_delete_request(false)
        fetchAllScheme()
            })
        }
        if(edit_delete_request_input.service==="Logistic Educator Delight Gift"){
        setindecator(true)
            
            axios.post('/edit_logistic_educator_delight_gift', {
                data:edit_delete_request_input,
                user_id:props.userData.id
            }).then((res)=>{
        setindecator(false)
        setedit_delete_request(false)
        fetchAllScheme()
                // console.log("Logistic Educator Delight Gift",res.data)
            })
        }
        if(edit_delete_request_input.service==="Bithdays and anniversaries Trac"){
        setindecator(true)
            
            axios.post('/edit_birthday_aniverssary_service', {
                data:edit_delete_request_input,
                user_id:props.userData.id
            }).then((res)=>{
        setindecator(false)
        setedit_delete_request(false)
        fetchAllScheme()
                // console.log("Bithdays and anniversaries Trac",res.data)
            })
        }
        if(edit_delete_request_input.service==="Stamp Paper"||edit_delete_request_input.service==='E-Stamp Paper'){
            setindecator(true)
                edit_delete_request_input.Total_Amount=edit_delete_request_input.total_amount
                edit_delete_request_input.name_of_second_party=edit_delete_request_input.second_party_name
                axios.post('/edit_stamp_paper', {
                    data:edit_delete_request_input,
                    user_id:props.userData.id,
                    scheme_id:props.userData.corporate_id
                }).then((res)=>{
            setindecator(false)
            setedit_delete_request(false)
            fetchAllScheme()
                    // console.log("Bithdays and anniversaries Trac",res.data)
                })
            }
    }

    const fetscallScheme=()=>{
        console.log('testin============g',props)
        axios.get('/get_schemes_stamp_paper?user_id='+props.userData.id).then((res)=>{
          console.log(res,'teesting============2')
          allcorporate=[]
          if(Array.isArray(res.data.data)){
            res.data.data.forEach(key=>{
              if(JSON.parse(key.id)===JSON.parse(props.userData.corporate_id)){
                setselected_sceme(key.id)
              }
            })
            for(let i=0;i<props.userData.corporate.length;i++){
              res.data.data.forEach(key=>{
                if(props.userData.corporate[i].toLowerCase()===key.scheme_name.toLowerCase()){allcorporate.push({id:key.id, scheme_name:key.scheme_name, payment_mode:key.payment_mode})
                }
              })
            }
          }
          setscheme(res.data.data)
        })
      }

        
      const get_call_log_user=()=>{
        axios.get('/get_call_log_user?user_id='+props.userData.id).then((res)=>{
          if(res.data){
            if(res.data.length!==0){
              setget_call_log_user(res.data[0])
            }
          }
        })
      }


    const fetchAllScheme=async ()=>{
        scheme_auth=false
        setindecator(true)
      await  axios.get('/get_schemes_stamp_paper').then((res)=>{
            if(Array.isArray(res.data.data)){
                let misfaseTrue=false
                res.data.data.forEach(key=>{
                    if(JSON.parse(key.id)===JSON.parse(props.userData.corporate_id)){
                            if(key.scheme_name==='Unacademy'){
                            //    setceckMisschem(false)
                            setserviceName(['Bithdays and anniversaries Trac', 'Educator Delight - Admin sheet','Logistic Educator Delight Gift'])
                            misfaseTrue=false
                            }else{
                                setserviceName(['Stamp Paper', 'E-Stamp Paper', 'Franking', 'E-Franking', 'Notary', 'E-Sign'])
                            //    setceckMisschem(true)
                            misfaseTrue=true
                        }
                    }
                    else if(props.userData.corporate_id===1){
                        // setceckMisschem(true)
                        setserviceName(['Stamp Paper', 'E-Stamp Paper', 'Franking', 'E-Franking', 'Notary', 'E-Sign', "Gifting Delivery for Educators", 'Bithdays and anniversaries Trac', 'Educator Delight - Admin sheet','Logistic Educator Delight Gift'])
                        misfaseTrue=true
                    }
                })
                setceckMisschem(misfaseTrue)
                // console.log(misfaseTrue)
                scheme_auth=true
                setindecator(false)
                
                if(scheme_auth){
                    // console.log(checkMisScheme, scheme_auth)
                    if(misfaseTrue===false){
                        fetchMisforunacadamy()
                        get_web_app_report_birth_anniversary()
                    }
                    if(misfaseTrue===true){

                        fetchData() 
                    }
                    get_user_list_admin()
                }
                
        }
        
    })
}
const get_user_list_admin=()=>{
    axios.get('/get_user_list_admin?user_id='+props.userData.id).then((res)=>{
        if(Array.isArray(res.data)){
            setget_user_list_admin(res.data)
        }
    })
}
const fetchData=(seleid)=>{
    let id=seleid?seleid:selectuser.id
    console.log('dsjdsj',id)
        setdata([])
        setindecator(true)
        // console.log('/get_web_app_request_report?user_id='+id)
        axios.get('/get_specific_report?user_id='+id).then(resp=>{
            setindecator(false)
            if(!resp.data.error){
                if(Array.isArray(resp.data)){
                    console.log('dkdsmksdlds', resp.data)
                        if(resp.data.length!==0){
                            setdata(resp.data)
                            setfilterdata(resp.data)
                        }
                    
                }
            }
        })
        .catch((err)=>{
            // console.log(err)
            setindecator(false)
        })
}
const filter_data=(ev)=>{
    setsearch({...search, ddate:'', rdate:'', sname:'', city:'', reqId:'', scheme:'', corporate_id:''})

    let currentdate=new Date().getTime()
    let twentyfourhrdate=new Date().getTime()-(ev * 24 * 60 * 60 * 1000)
    let ndata=data.filter(key=>{
        let date_timeasapi=key.created_at.split(' ')
        let time=date_timeasapi[1].split(':')
        let timestampasapi=new Date(date_timeasapi[0].split('-').reverse().join("-")).getTime()
    //    console.log(timestampasapi, twentyfourhrdate, currentdate)
       
        if(timestampasapi>=twentyfourhrdate&&timestampasapi<=currentdate){
          return key
        }
    })
    setfilterdata(ndata)
    filterMisData()
   
}
const filterDateRange=()=>{
    let startdate=search.rdate
    let enddate=search.ddate
    let ndata;
    if(startdate!==''&&enddate!==''){
         ndata=data.filter(key=>{
            let createddatetimstamp=new Date(key.created_at.split(' ')[0].split('-').reverse().join("-")).getTime()
            if(createddatetimstamp>=new Date(startdate).getTime()&&createddatetimstamp<=new Date(enddate).getTime()){
                // console.log('dskdsmkds')
                return key
            }

        })
        setfilterdata(ndata)
        filterMisData()
    }
}
const fetchMisforunacadamy=(seleid)=>{
         let id=seleid?seleid:props.userData.id

        // console.log(ev)
        setindecator(true)
// get_web_app_request_report_gift_delivery
        axios.get('/get_web_app_report_logistic_educator_delight_gift?user_id='+id).then((res)=>{
            // console.log('res.data', res.data, id)

            setfetchMisforunacadamy(res.data)
            setindecator(false)

        }).catch((err)=>{
            if(err) throw err
        setindecator(false)

        })
}
const get_web_app_report_birth_anniversary=(seleid)=>{
    let id=seleid?seleid:props.userData.id
   
    setindecator(true)
// get_web_app_request_report_gift_delivery
                    setmisforBirhday([])
                    setdata([])
                    setmisforservicescopy([])
                    setfilterdata([])
    axios.get('/get_web_app_report_birth_anniversary?user_id='+id).then((res)=>{
            // console.log('res.data', res.data, id)
            if(Array.isArray(res.data)){
                if(res.data.length!==0){
                    setmisforBirhday(res.data)
                    setdata(res.data)
                    setmisforservicescopy(res.data)
                    setfilterdata(res.data)
                    setmisforservices('1')
                    setindecator(false)
                }
            }
            
        }).catch((err)=>{
            if(err) throw err
            setindecator(false)
            
        })
}
const filterMisData=()=>{
    let ndata=JSON.parse(JSON.stringify(filterdata));
    selection_export_excel.forEach((key)=>{
        if(key.isSelected===false){
            ndata.forEach(keys=>{
                delete keys[key.keyname]
            })
        }
    })
    setexceldata(ndata)
}
const filter_all=()=>{
    setsearch({...search, ddate:'', rdate:'', sname:'', city:'', reqId:'', scheme:'', corporate_id:''})

    setfilterdata(data)
    filterMisData()
   
}
const getAll_city_list=()=>{
    axios.get('/get_cities_by_state').then((res)=>{
        setcityList(res.data)
    })
}
useEffect(()=>{
    getAll_city_list()
    fetscallScheme()
    get_call_log_user()
}, [])
console.log('mi',misforservices)
useEffect(async ()=>{
   await fetchAllScheme()
    // console.log('scheme_auth', scheme_auth)
    
}, [])
let status=['Work in Progress','Initialized', 'New', 'Completed']
let month=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Des']
const filter_all_by_ri_sn_ci_rd_dd=filterdata.filter(key=>{
    
    try{
        if(search.scheme||search.reqId||search.sname||search.city||search.rdate||search.ddate||search.corporate_id){
            console.log('search=',key)                                                                                           
                    
                    if(
                        key.reqId.toUpperCase().includes(search.reqId.toUpperCase())
                        && 
                        key.service.toUpperCase().includes(search.sname.toUpperCase())
                        &&
                        key.city.toUpperCase().includes(search.city.toUpperCase())
                        &&
                        JSON.stringify(key.corporate_id).includes(search.corporate_id)
                        ){
                        console.log('if call')
                        return  true
                    }else{
                        console.log('else call')
                        return false
                    }

                }else{
                    return true

                }
            }catch(err){}
        })
        // console.log(search)
        return(
            <div >
            
            <div className="Report">
            <p>REPORT </p>
            </div>
        <Card className="ContainerCard1">
        <table>
        <tr>
        <th><p className="firstrow">Client</p></th>
            <th><p className="firstrow">Request ID</p></th>
            <th><p className="firstrow">Service Name</p></th>
            <th>
                <p className="firstrow">City</p>
            </th>
            
        </tr>
        <tr>
    
            <td>
                {/* <SelectSchemeReport userData={data.userDetails} /> */}
                <select className='form-select' value={search.corporate_id} onChange={(scheme_sele=>{
                    // console.log(scheme_sele.target.value)
                    setsearch({...search, corporate_id:scheme_sele.target.value})
                })}>
            <option value="" >Selected Scheme</option>
            {Array.isArray(props.userData.corporate)&&
              allcorporate.map((schemeval, i)=>{
            return(
                 <option key={i} value={schemeval?.id}>{schemeval.scheme_name}</option>
                  )
            }
            )  
            }
            
            </select>
    
            </td>
    
            <td>    
                <input type="text" onChange={(ev)=>{
                    setsearch({...search, reqId:ev.target.value})
                }} value={search.reqId} name="reqid" className="inputtext" placeholder="Request ID" />
            </td>
           
            <td>
                {/*
                    <input type="text" onChange={(ev)=>{
                        setsearch({...search, sname:ev.target.value})
                    }} name="sname" value={search.sname} className="inputtext" placeholder="Service Name" />
                */}
                <select className='form-select' value={search.sname} onChange={(ev)=>{
                    setsearch({...search, sname:ev.target.value})
                    let mis_of_services=''
                    if(checkMisScheme===false){
    
                        if(ev.target.value==='Bithdays and anniversaries Trac'){
                            mis_of_services='1'
                            setmisforeducator([])
                            
                            setmisforlogistic([])
                            setmisforBirhday(misforservicesCopy)
                            setdata(misforservicesCopy)
                            setfilterdata(misforservicesCopy)
                        }
                        if(ev.target.value==='Educator Delight - Admin sheet'){
                            mis_of_services='2'
                            let birthdayMis=fetchMisforunac.filter(key=>{
                                if(key.service==="Educator Delight - Admin sheet"){
                                    let nGift_Name='', nGift_Link='', nItem_cost='';
                                    try{
                                        let nGift_link_multiple=JSON.parse(key.Gift_link_multiple)
                                        
                                        if(Array.isArray(nGift_link_multiple)){
                                            for(let k=0;k<nGift_link_multiple.length;k++){
                                                nGift_Name+=nGift_link_multiple[k].Gift_Name+','
                                                nGift_Link+=nGift_link_multiple[k].Gift_Link+','
                                                nItem_cost+=nGift_link_multiple[k].Item_cost+','
                                            }
                                        }
                                        key.nGift_Name=nGift_Name;
                                        key.nGift_Link=nGift_Link;
                                        key.nItem_cost=nItem_cost;
        
                                    }catch(err){}
                                    // console.log('dkdkd',nGift_Name, nGift_Link, nItem_cost)
                                    return key;
                                }
                            })
                            setmisforBirhday([])
                            
                            setmisforeducator(birthdayMis)
                            setdata(birthdayMis)
                             setfilterdata(birthdayMis)
                            setmisforlogistic([])
                        }
                        if(ev.target.value==='Logistic Educator Delight Gift'){
                            mis_of_services='3'
        
                                    let birthdayMis=fetchMisforunac.filter(key=>{
                                        if(key.service=== "Logistic Educator Delight Gift"){
                                            return key;
                                        }
                                    })
                                    setmisforlogistic(birthdayMis)
                                    setdata(birthdayMis)
                    setfilterdata(birthdayMis)
                                    setmisforBirhday([])
                                    setmisforeducator([])
                        }
                        setmisforservices(mis_of_services)
                    }
    
                }}>
                    <option key='-1' value=''>Select Service name</option>
                    {serviceName.map((val, k)=>{
                       return <option key={k} value={val}>{val}</option>
                    })}
                </select>
            </td>
            <td>
                {/*
                    <input type="text" onChange={(ev)=>{
                        setsearch({...search, city:ev.target.value})
                    }} name="city" value={search.city} className="inputtext" placeholder="City" />
                */}
                <input list="brow" name="city" value={search.city} className="form-select"
                
                placeholder="City"  onChange={(ev)=>{
                    setsearch({...search, city:ev.target.value})
                }}/>
                <datalist id="brow">
                    {getcityList.map((val, l)=>{
                        return(
                            <option key={l} value={val.name}>{val.name}</option>
                        )
                    })}
                </datalist>  
                {/*
                    <select className='form-select' onChange={(ev)=>{
                        setsearch({...search, city:ev.target.value})
                    }}>
                        <option value=''>Select City</option>
                        {getcityList.map((val, l)=>{
                            return(
                                <option key={l} value={val.name}>{val.name}</option>
                            )
                        })}
                    </select>
                */}
            </td>
            
        </tr>
        </table>
        <div style={{display:'flex', flexDirection:'row'}}>
            <div>
                <div>
                    <label style={{color:'#FFF'}}>From</label>
                </div>
                <input type="date" onChange={(ev)=>{
                    setsearch({...search, rdate:ev.target.value})
                }} name="Rdate" value={search.rdate} className="inputtext" placeholder="Requested Date" />
            </div>
            <div>
                <div>
                    <label style={{color:'#FFF'}}>To</label>
                </div>
                <input type="date" style={{
                    marginLeft:5
                }} onChange={(ev)=>{
                    setsearch({...search, ddate:ev.target.value})
                }} name="Ddate" value={search.ddate} className="inputtext" placeholder="Delivery Date" />
            </div>
        </div>
       
        <div>
            <Button onClick={()=>{
                filterDateRange()
            }}>Submit</Button>
        </div>
        {(props.userData.is_admin||props.userData.is_super_admin)&&
            <div style={{
                paddingTop:10,
                paddingBottom:10,
                width:300
            }}>
            <select value={JSON.stringify({id:selectuser.id, name:selectuser.name})}  onChange={(ev)=>{
                let selectedval=JSON.parse(ev.target.value)
                setsetselectuser({...selectuser, name:selectedval.name, id:selectedval.id})
                if(ev){
                    if(checkMisScheme){
    
                        fetchData(selectedval.id)
                    }else{
                        fetchMisforunacadamy(selectedval.id)
                        get_web_app_report_birth_anniversary(selectedval.id)
                    }
                }
    
            }} className="form-select">
                {user_list_admin.map((val, i)=>{
                    return(
                        <option value={JSON.stringify({id:val.id, name:val.name})} key={i}>{val.name}</option>
                    )
                })}
            </select>
          </div>
        }
        <div className="element5 element">
    <p className="secondrow">Date Range</p>
    {buttonselected.map((val, i)=>{
        return(
            <Button variant="flat" style={{
                backgroundColor:val.selected&&'yellow'
            }} onClick={()=>{
                if(val.val==='all'){
                    filter_all()
                }else{
                    filter_data(val.val)
                } 
                let nbutton=[...buttonselected]
                nbutton.forEach((key, j)=>{
                    
                    nbutton[j].selected=false
                })
                nbutton[i].selected=!val.selected
                
                // console.log(nbutton)
                setbuttonSelected(nbutton)
           }}><span style={{color:'#FFF', fontSize:20}} >{val.label}</span></Button> 
        )
    })}
     
    </div>
    </Card>
    <Card style={{
        background:'transparent', border:0, marginRight:100
    }}>
        <div className="MiddleContainer">
            <div style={{width:'30%'}}>
                <p className="reportsummarytext">REPORT SUMMARY</p>
            </div>
            <div style={{width:'60%', display:'flex', justifyContent:'center'}}>
            {checkMisScheme===true?
                <Button onClick={()=>{
                    popupmodal.current.open()
                }}>MIS Reports</Button>
                :
                <div style={{display:'flex', alignItems:'center'}}>
                    <select
                    value={misforservices}
                    style={{
                        height:40,
                        width:200,
                        marginRight:10
                    }} className='form-select'
                    onChange={(ev)=>{
                        let searchName=''
                        setTarget_summery(null)
                        ref_summery.current=null
                        setShow_summery(false);

                        setmisforservices(ev.target.value)
                        if(ev.target.value==='1'){
                            searchName='Bithdays and anniversaries Trac'
                            setmisforeducator([])
                            
                            setmisforlogistic([])
                            setmisforBirhday(misforservicesCopy)
                            setdata(misforservicesCopy)
                            setfilterdata(misforservicesCopy)
                        }
                        if(ev.target.value==='2'){
                            searchName='Educator Delight - Admin sheet'

                            let birthdayMis=fetchMisforunac.filter(key=>{
                                if(key.service==="Educator Delight - Admin sheet"){
                                    let nGift_Name='', nGift_Link='', nItem_cost='';
                                    try{
                                        let nGift_link_multiple=JSON.parse(key.Gift_link_multiple)
                                        
                                        if(Array.isArray(nGift_link_multiple)){
                                            for(let k=0;k<nGift_link_multiple.length;k++){
                                                nGift_Name+=nGift_link_multiple[k].Gift_Name+','
                                                nGift_Link+=nGift_link_multiple[k].Gift_Link+','
                                                nItem_cost+=nGift_link_multiple[k].Item_cost+','
                                            }
                                        }
                                        key.nGift_Name=nGift_Name;
                                        key.nGift_Link=nGift_Link;
                                        key.nItem_cost=nItem_cost;

                                    }catch(err){}
                                    // console.log('dkdkd',nGift_Name, nGift_Link, nItem_cost)
                                    return key;
                                }
                            })
                            setmisforBirhday([])
                            
                            setmisforeducator(birthdayMis)
                            setdata(birthdayMis)
                             setfilterdata(birthdayMis)
                            setmisforlogistic([])
                            
                        }
                        if(ev.target.value==='3'){
                            searchName='Logistic Educator Delight Gift'

                            let birthdayMis=fetchMisforunac.filter(key=>{
                                if(key.service=== "Logistic Educator Delight Gift"){
                                    return key;
                                }
                            })
                            setmisforlogistic(birthdayMis)
                            setdata(birthdayMis)
            setfilterdata(birthdayMis)
                            setmisforBirhday([])
                            setmisforeducator([])
                        }
                        if(ev.target.value===''){
                            // console.log('dssdksd')
                            searchName=''
                            setmisforBirhday([])
                            setmisforeducator([])
                            
                            setmisforlogistic([])
                            setdata([])
                            setfilterdata([])
                        }
                        setsearch({...search, sname:searchName})

                    }}
                    >
                        <option value=''>Select Services</option>
                        <option value='1'>Bithdays and anniversaries Trac</option>
                        <option value='2'>Educator Delight - Admin sheet</option>
                        <option value='3'>Logistic Educator Delight Gift</option>
                    </select>
                {(misforBirhday.length!==0&&misforservices==='1')&&
                    <div>
                        
                        <ExcelFile  element={<div>
                            <Button variant="warning"><span style={{color:'#FFF',fontSize:20}}>Export to Excel</span></Button>
                                </div>
                            }>
                                <ExcelSheet data={misforBirhday} name="Employees">
                                <ExcelColumn  label="Date request raised" value="created_at"/>
                                <ExcelColumn label="Merchant Name" value="service"/>
                                <ExcelColumn label="Scheme" value="scheme"/>
                                <ExcelColumn label="Request Id" value="reqId"/>
                                <ExcelColumn label="Status" value="currentStatus"/>
                                <ExcelColumn label="Status" value="currentStatus"/>

                                <ExcelColumn label="City" value="city"/>
                                <ExcelColumn label="Level" value="Level"/>
                                <ExcelColumn label="Event Date" value="Event_Date"/>
                                <ExcelColumn label="Event Title" value="event_title"/>
                                <ExcelColumn label="Event Title Other" value="event_title_other"/>
                                <ExcelColumn label="Current Address" value="Current_Address"/>
                                <ExcelColumn label="Contact Number" value="Contact_Number"/>
                                <ExcelColumn label="Gifting Option" value="Gifting_option"/>
                                <ExcelColumn label="Dispatched Status" value="dispatched_status"/>
                                <ExcelColumn label="Dispatched Date" value="dispatched_date"/>
                                <ExcelColumn label="Tracking Number" value="tracking_number"/>
                                <ExcelColumn label="Courier Service" value="courier_service"/>
                                <ExcelColumn label="Received by Educator" value="received_by_educator"/>
                                <ExcelColumn label="Educator Reaction" value="educator_reaction"/>
                                <ExcelColumn label="Admin Comments" value="admin_comments"/>
                                </ExcelSheet>
                            </ExcelFile>
                    </div>
                }
                {(misforeducator.length!==0&&misforservices==='2')&&
                    <div>
                        
                        <ExcelFile  element={<div>
                            <Button variant="warning"><span style={{color:'#FFF',fontSize:20}}>Export to Excel</span></Button>
                                </div>
                            }>
                                <ExcelSheet data={misforeducator} name="Employees">
                                <ExcelColumn  label="Date request raised" value="created_at"/>
                                <ExcelColumn label="Merchant Name" value="service"/>
                                <ExcelColumn label="Scheme" value="scheme"/>
                                <ExcelColumn label="Request Id" value="reqId"/>
                                <ExcelColumn label="State" value="state"/>
                                <ExcelColumn label="City" value="city"/>
                                <ExcelColumn label="Educator Id" value="Educator_Id"/>
                                <ExcelColumn label="Educator Name" value="Educator_Name"/>
                                <ExcelColumn label="Educator unacademy profile link" value="educator_unacademy_profile_link"/>
                                <ExcelColumn label="Educator Profile Link Email Id" value="Educator_Profile_Link_Email_Id"/>
                                <ExcelColumn label="Category" value="Category"/>
                                <ExcelColumn label="Director" value="Director"/>
                                <ExcelColumn label="Occasion" value="Occasion"/>
                                <ExcelColumn label="Details of Occasion" value="Details_of_Occasion"/>
                                <ExcelColumn label="Contact Number" value="Contact_Number"/>
                                <ExcelColumn label="Address" value="Address"/>
                                <ExcelColumn label="Gift" value="Gift"/>
                                <ExcelColumn label="PR No" value="PR_No"/>
                                <ExcelColumn label="PR value" value="PR_value"/>
                                <ExcelColumn label="PO Number" value="PO_Number"/>
                                <ExcelColumn label="Total Cost" value="Total_Cost"/>
                                <ExcelColumn label="Message on Amazon Smoor Card Gift Wrap" value="Message_on_Amazon_Smoor_Card_Gift_Wrap"/>
                                <ExcelColumn label="Occation Sub Type" value="Occation_Sub_Type"/>
                                <ExcelColumn label="Type of Educator" value="type_of_educator"/>
                                <ExcelColumn label="Educator Value" value="Educator_value"/>
                                <ExcelColumn label="Gift Link" value="Gift_link"/>
                                <ExcelColumn label="Alternative Contact" value="Alternative_Contact"/>
                                <ExcelColumn label="Pin Code" value="pin_code"/>
                                <ExcelColumn label="Gift Name" value="nGift_Name"/>
                                <ExcelColumn label="Gift Link" value="nGift_Link"/>
                                <ExcelColumn label="Item cost" value="nItem_cost"/>
                                <ExcelColumn label="Remarks" value="remarks"/>

                                <ExcelColumn label="Dispatched Status" value="dispatched_status"/>
                                <ExcelColumn label="Dispatched Date" value="dispatched_date"/>
                                <ExcelColumn label="Tracking Number" value="tracking_number"/>
                                <ExcelColumn label="Courier Service" value="courier_service"/>
                                <ExcelColumn label="Received by Educator" value="received_by_educator"/>
                                <ExcelColumn label="Educator Reaction" value="educator_reaction"/>
                                <ExcelColumn label="Admin Comments" value="admin_comments"/>

                                </ExcelSheet>
                            </ExcelFile>
                    </div>
                }
                {(misforlogistic.length!==0&&misforservices==='3')&&
                    <div>
                        
                        <ExcelFile  element={<div>
                            <Button variant="warning"><span style={{color:'#FFF',fontSize:20}}>Export to Excel</span></Button>
                                </div>
                            }>
                                <ExcelSheet data={misforlogistic} name="Employees">
                                <ExcelColumn  label="Date request raised" value="created_at"/>
                                <ExcelColumn label="Merchant Name" value="service"/>
                                <ExcelColumn label="scheme" value="scheme"/>
                                <ExcelColumn label="Request Id" value="reqId"/>
                                <ExcelColumn label="State" value="state"/>
                                <ExcelColumn label="City" value="city"/>
                                <ExcelColumn label="Educator Id" value="Educator_Id"/>
                                <ExcelColumn label="Educator Name" value="Educator_Name"/>
                                <ExcelColumn label="Educator unacademy profile link" value="educator_unacademy_profile_link"/>
                                <ExcelColumn label="What Category does the educator teach
                                in" value="Educator_Profile_Link_Email_Id"/>
                                <ExcelColumn label="Category" value="Category"/>
                                <ExcelColumn label="Relationship Manager" value="Director"/>
                                <ExcelColumn label="Occasion" value="Occasion"/>
                                <ExcelColumn label="Details of Occasion" value="Details_of_Occasion"/>
                                <ExcelColumn label="Date of Occassion" value="Date_of_Occassion"/>
                                <ExcelColumn label="Date_of_Occassion" value="Contact_Number"/>
                                <ExcelColumn label="Educator's Current Address" value="Address"/>
                                <ExcelColumn label="Gift" value="Gift"/>
                                <ExcelColumn label="Educator's Pin code" value="pin_code"/>
                                <ExcelColumn label="PR value" value="PR_value"/>
                                <ExcelColumn label="Additonal Item cost" value="Additonal_Item_cost"/>
                                <ExcelColumn label="PR No" value="PR_No"/>
                                <ExcelColumn label="Total Cost" value="Total_Cost"/>
                                <ExcelColumn label="Message on Amazon Smoor Card Gift Wrap" value="Message_on_Amazon_Smoor_Card_Gift_Wrap"/>
                                <ExcelColumn label="Gifting Details(What would you like to
                                    send to the educator, please add
                                    links for the items)" value="Occation_Sub_Type"/>

                                </ExcelSheet>
                            </ExcelFile>
                    </div>
                }
                </div>
            }
            
                 
            </div>
        </div>
    </Card>
    <Card className="ContainerCard2" style={{padding:30}}>
      
        <table >
        <thead>
            <tr>
                <th>Request Date</th>
                <th>Request ID</th>
                <th>Services</th>
                {(misforservices==='2'||misforservices==='3'||misforservices==='1')&&
                <th>Educator Name</th>
                }
                <th>Status</th>
                <th>Download</th>
                <th>User Name</th>
            </tr>
        </thead>
        <tbody>
        {filter_all_by_ri_sn_ci_rd_dd.map((vakue, i)=>{
            let date=vakue.created_at.split('T')[0].split('-')
            
            console.log('dddssd',vakue)
            return(
                <tr key={i}>
                    <td>{parseInt(date[2])} {month[parseInt(date[1])-1]} {parseInt(date[0])}</td>
                    <td>
                    <span 
                    // style={{
                    //     cursor:'pointer',
                    //     color:'blue',
                    //     textDecoration:'underline'
                    // }} 
                    ref={ref_summery} onClick={(ev)=>{
                        // setsummery_data(vakue)
                        // setShow_summery(!show_summery);
                        // setTarget_summery(ev.target);
                        //console.log('hello')
                    }}>
                         {vakue.reqId}</span>
                     </td>
                    <td style={{
                        cursor:'pointer',
                        color:'#fff',
                        textDecoration:'underline'
                    }} onClick={()=>{
                        vakue['gift_details']=vakue.Gift_link_multiple
                        setedit_delete_request_input(vakue)
                        setedit_delete_request(true)
                    }}>{vakue.service}</td>
                    {(misforservices==='2'||misforservices==='3'||misforservices==='1')&&
                    <th>{vakue.Educator_Name}</th>
                    }
                    <td>
                    {vakue.currentStatus}
                    {/*
                        <Popup
                            ref={popoverref}
                           trigger={<div style={{
                               cursor:'pointer',
                           }}> {vakue.currentStatus} </div>}
                           position='bottom center'
                           on="hover"
                           
                           closeOnDocumentClick={true}
                           mouseLeaveDelay={100}
                           mouseEnterDelay={0}
                           contentStyle={{ padding: '0px', border: 'none' }}
                           arrow={false}
                           >
                           <div className="menu">
                            {status.map((stat, j)=>{
                                return(
                                    <div onClick={(ev)=>{
                                        
                                        let narr=[...data];
                                       narr[i].currentStatus=stat
                                       narr[i].fileuplad=stat==='Completed'?true:false
                                       setdata(narr)
                                       popoverref.current.close()
                                       
                                    }} className="menu-item" key={j}>{stat}</div>
                                )
                            })}
                           </div>
                           </Popup>
                    */}
                    </td>   
                    <td>
                        <span style={{
                            textDecoration:'underline',
                            color:'#fff',
                            cursor:'pointer'
                        }} onClick={()=>{
                            axios.get('/download_documents?reqId='+vakue.reqId, {
                                reqId:vakue.reqId
                            }).then((res)=>{
                                if(res.data){
                                    if(Array.isArray(res.data)){
                                        if(res.data.length!==0){
                                            window.open(
                                                res.data[0].path,
                                                '_blank' // <- This is what makes it open in a new window.
                                              );
                                        }
                                    }
                                }
                            })
                        }} >Document for {vakue.reqId}</span>
                    </td>
                    <td>
                    {vakue.created_by}
                    </td>
                   
                </tr>
            )
            })}
        </tbody>
    </table>
    </Card>
    <OverLay active={indicator}/>
    
    <Popup
    ref={popupmodal}
    // trigger={<button className="button"> Open Modal </button>}
    modal
    nested>
            {close=>(
                <div>
                <div>
                    {selection_export_excel.map((dat, i)=>{
                        return(
                            <div key={i}>
                                <input defaultValue={dat.isSelected} checked={dat.isSelected} onChange={(ev)=>{
                                    let nselection_export_excel=[...selection_export_excel]
                                    nselection_export_excel[i].isSelected=!dat.isSelected 
                                    
                                    setselection_export_excel(nselection_export_excel)
                                    filterMisData()
                                }} type='checkbox'/>
                                <label>{dat.label}</label>
                            </div>
                        )
                    })}
                </div>

                <div style={{
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'end'
                }}>
                    <Button onClick={()=>{
                        close()
                    }}>close</Button>
                    <div>
                    {/*
                        <ExcelFile  element={<div>
                            <Button variant="warning"><span style={{color:'#FFF',fontSize:20}}>Export to Excel</span></Button>
                            </div>
                        }>
                            {exceldata.length!==0&&
                                <ExcelSheet data={exceldata} name="Employees">
                                {selection_export_excel[0].isSelected&&
                                    <ExcelColumn  label="Date request raised" value="created_at"/>
                                }
                                {selection_export_excel[1].isSelected&&
                                    <ExcelColumn label="Merchant Name" value="service"/>
                                }
                                {selection_export_excel[2].isSelected&&
                                    <ExcelColumn label="City" value="city"/>
                                }
                                {selection_export_excel[3].isSelected&&
                                    <ExcelColumn label="Description of request (only stamp paper/ stamp paper and docs/ only docs)" value="description"/>
                                }
                                {selection_export_excel[4].isSelected&&
                                    <ExcelColumn label="Tracking Number" value="reqId"/>
                                }
                                {selection_export_excel[5].isSelected&&
                                    <ExcelColumn label="Courier service name" value="courier_service"/>
                                }
                                {selection_export_excel[6].isSelected&&
                                    <ExcelColumn label="Date of Docs Delivery (DD-MMM-YY)" value="date_of_delivery"/>
                                }
                                {selection_export_excel[7].isSelected&&
                                    <ExcelColumn label="Time Taken for delivery" value="time_taken_for_delivery"/>
                                }
                                {selection_export_excel[8].isSelected&&
                                    <ExcelColumn label="Days Since /n Request Raised for Undelivered cases" value="date_request_raised"/>
                                }
    
                                </ExcelSheet>
                                
                            }
                            </ExcelFile>
                        */}
                        <ExcelFile  element={<div>
                            <Button variant="warning"><span style={{color:'#FFF',fontSize:20}}>Export to Excel</span></Button>
                                </div>
                            }>
                                <ExcelSheet data={exceldata} name="Employees">
                                <ExcelColumn  label="Request Id" value="reqId"/>
                                <ExcelColumn  label="Service Name" value="service"/>
                                <ExcelColumn  label="Date request raised" value="created_at"/>
                                <ExcelColumn label="Merchant Name" value="second_party_name"/>
                                <ExcelColumn label="Scheme" value="scheme"/>
                                <ExcelColumn label="City" value="city"/>
                                <ExcelColumn label="Description of request (only stamp paper/ stamp paper and docs/ only docs)" value="description"/>
                                <ExcelColumn label="Tracking Number" value="tracking_details"/>
                                <ExcelColumn label="Courier service name" value="courier_service"/>
                                <ExcelColumn label="Date of Docs Delivery
                                (DD-MMM-YY)" value="date_of_delivery"/>
                                <ExcelColumn label="Time Taken for delivery" value="time_taken_for_delivery"/>
                                <ExcelColumn label="Days Since /n Request Raised for Undelivered cases" value="date_request_raised"/>
                
                                </ExcelSheet>
                            </ExcelFile>
    
                    </div>
                </div>
                </div>
            )}
            </Popup>
    {show_summery&&
        <div>
            <Overlay
                show={show_summery}
                target={target_summery}
                placement="bottom"
                // container={ref_summery}
                containerPadding={20}
                rootClose={true}
            
            >
                            
                <div  className='popover' onClick={()=>{
                    setShow_summery(false);
                }} style={{
                    background:'#fff', 
                    width:'300px', 
                    height:'300px',
                marginTop:15
                }}>
                    <div style={{
                        position:'absolute',
                        content:'',
                        width:0,
                        height:0,
                        border: '17px solid transparent',
                        borderBottomColor:'#ddd',
                        left:'44%',
                        top:'-34px'
                    }}></div>
                    <div className='popover-content' style={{
                    overflow:'auto',
                        height:300,
                    }}>
                        {Object.keys(summery_data).map((data, i)=>{
                            if(data!=='reqId'){
                                return(
                                    <div key={i}>
                                        <div>
                                            <strong style={{
                                                color:'#000'
                                            }}>{data.split('_').join(' ')}</strong>
                                        </div>
                                        <div>
                                            <span style={{color:'#000'}}>{summery_data[data]}</span>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </div>
            </Overlay>
        </div>
    }   
    <Modal  show={edit_delete_request} onHide={()=>{
        setedit_delete_request(false)
    }}>
    <Modal.Header closeButton={true} closeLabel=''>
      <Modal.Title></Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {Object.keys(edit_delete_request_input).map((valk, i)=>{
            if(valk==='Gift_link_multiple'){
               
                let gift_data=[];
                    try{
                        if(Array.isArray(JSON.parse(edit_delete_request_input['Gift_link_multiple']))){
                            gift_data=JSON.parse(edit_delete_request_input['Gift_link_multiple'])
                        }
                    }
                    catch(err){}
                    // console.log('gift_data', gift_data)
                return(
                    <div style={{
                        display:'flex',
                        flexDirection:'column'
                    }}>
                        {gift_data.length!==0&&
                            <div style={{
                                display:'flex', flexDirection:'row',
                                justifyContent:'space-between',
                                alignItems:'center'
                            }}>
                                <div style={{width:'33%'}}>
                                    <label>Gift Name</label>
                                </div>
                                <div style={{width:'33%'}}>
                                    <label>Gift Link</label>
                                </div>
                                <div style={{width:'33%'}}>
                                    <label>Item cost</label>
                                </div>
                            </div>
                        }
                        {gift_data.map((giftval, j)=>{
                           return <div style={{
                                display:'flex', flexDirection:'row'
                            }}>
                                <div>
                                    <input className='form-control'
                                    onChange={(ev)=>{
                                    let nedit_delete_request_input={...edit_delete_request_input}
                                    try{
                                        let gift_det_new=JSON.parse(nedit_delete_request_input[valk])
                                            gift_det_new[j].Gift_Name=ev.target.value       
                                            nedit_delete_request_input[valk]=JSON.stringify(gift_det_new)
                                            nedit_delete_request_input['gift_details']=JSON.stringify(gift_det_new)
                                            setedit_delete_request_input(nedit_delete_request_input)
                                           
                                        }catch(err){

                                        }
                                    }}
                                    value={giftval.Gift_Name}/>
                                </div>
                                <div>
                                    <input className='form-control'
                                    onChange={(ev)=>{
                                        let nedit_delete_request_input={...edit_delete_request_input}
                                        try{
                                            let gift_det_new=JSON.parse(nedit_delete_request_input[valk])
                                                gift_det_new[j].Gift_Link=ev.target.value       
                                                nedit_delete_request_input[valk]=JSON.stringify(gift_det_new)
                                            nedit_delete_request_input['gift_details']=JSON.stringify(gift_det_new)
                                               
                                                setedit_delete_request_input(nedit_delete_request_input)
                                               
                                            }catch(err){
    
                                            }
                                        }}
                                    value={giftval.Gift_Link}/>
                                </div>
                                <div>
                                    <input className='form-control'
                                    onChange={(ev)=>{
                                        let nedit_delete_request_input={...edit_delete_request_input}
                                        try{
                                            let gift_det_new=JSON.parse(nedit_delete_request_input[valk])
                                                gift_det_new[j].Item_cost=ev.target.value       
                                                nedit_delete_request_input[valk]=JSON.stringify(gift_det_new)
                                            nedit_delete_request_input['gift_details']=JSON.stringify(gift_det_new)
                                                
                                                setedit_delete_request_input(nedit_delete_request_input)
                                               
                                            }catch(err){
    
                                            }
                                        }}
                                    value={giftval.Item_cost}/>
                                </div>
                            </div>
                        })}
                    </div>
                )
            }
            if(valk==='scheme'||valk==='reqId'||valk==='service'||valk==='created_at'||valk==='currentStatus'||valk==='gift_details'||valk==='nGift_Name'||valk==='nGift_Link'||valk==='nItem_cost'||valk==='is_bulk_request'){
                return(
                    <div></div>
                )
            }
            else return(
                <div>
                    <div>
                        <label>{valk.split('_').join(' ')}</label>
                    </div>
                    <div>
                        <input className='form-control'
                        onChange={(ev)=>{
                            let nedit_delete_request_input={...edit_delete_request_input}
                            nedit_delete_request_input[valk]=ev.target.value
                            setedit_delete_request_input(nedit_delete_request_input)
                        }}
                        value={edit_delete_request_input[valk]}/>
                    </div>
                </div>
            )
        })}
    <OverLay active={indicator}/>

    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={()=>{
        setedit_delete_request(false)
      }}>
        Close
      </Button>
      <Button variant="primary" onClick={()=>{
        setedit_delete_request(false)
        edit_logistic_educator_delight_gift()  
    
    }}>
        Save Changes
      </Button>
    </Modal.Footer>
  </Modal>
    </div>
    
    )
}
export default Requesthistory;